/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from 'react-router-dom'
import { TimesheetApprovedEmail } from './components/TimesheetApprovedEmail'
import { InfoLayout } from './InfoLayout'

const InfoPage = () => (
  <Routes>
    <Route element={<InfoLayout />}>
      <Route path='TimesheetApprovedEmail' element={<TimesheetApprovedEmail />} />
      {/* <Route index element={<Error404 />} /> */}
    </Route>
  </Routes>
)

export { InfoPage }